import React from "react";
import { Button, Text } from "@fluentui/react-components";
import styles from "@/components/EmptyCard/EmptyCard.module.css";
import type { EmptyCardPropsInterface } from "@/components/EmptyCard/EmptyCard.types";

export const EmptyCard = React.memo((props: EmptyCardPropsInterface) => {
  const { img, title, description, link, primaryButton, secondaryButton } =
    props;
  return (
    <div className={styles.container}>
      <img alt={title} src={img} className={styles.img} />
      <Text align="center" size={500} weight="bold" className={styles.title}>
        {title}
      </Text>
      {description && (
        <Text align="center" size={300} className={styles.description}>
          {description}
        </Text>
      )}
      {link && (
        <Text
          align="center"
          size={300}
          className={styles.link}
          onClick={link.onClick}
        >
          {link.title}
        </Text>
      )}
      {primaryButton && (
        <Button
          onClick={primaryButton.onClick}
          appearance="primary"
          className={styles.button}
        >
          {primaryButton.title}
        </Button>
      )}
      {secondaryButton && (
        <Button onClick={secondaryButton.onClick} className={styles.button}>
          {secondaryButton.title}
        </Button>
      )}
    </div>
  );
});
